<template>
  <div class="page">
    <img
      :src="require('@/assets/images/not-found.png')"
      alt="Not Found"
      class="not-found-img"
    >
  </div>
</template>

<style lang="less" scoped>
.page {
  height: calc(100vh - 48px);
  display: flex;
  justify-content: center;
  align-items: center;
}

.not-found-img {
  width: 30%;
  max-height: 40%;
}
</style>
